import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Boolean Projections",
description: "Learn how to define boolean projections in Freon using textual and visual controls such as switches, checkboxes, and radio buttons, and how to override global boolean settings.",
tags: [ "boolean projections", "editor controls", "switch", "checkbox", "radio", "text display", "projectional editor", "global projections", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T18:12:52.262Z",
publishedTime: "2025-11-07T17:20:18.610Z"
    }
  };
};